import React from 'react';
import './maisDetalhes.scss';

//Componentes
import Breadcrumbs from '../../components/breadcrumbs';
import NavigationButtons from '../../components/navigationButtons';
import AreaField from '../../components/areaField';
import Field from '../../components/field';
import CheckObligation from '../../components/checkObligation'
import { string } from 'prop-types';

class MaisDetalhes extends React.Component {

  componentWillMount() {
    this.formFields = []
  }

  textAreaLabel() {

    let {
      tipoCadastro
    } = this.props;
    let stringParts = {}

    switch (tipoCadastro.tipoPessoaValue) {
      case "PessoaJuridica": 
        stringParts.exemplos = "compra de alguma mercadoria, pagamento de algum serviço";
        break;
      case "PessoaFisica": 
        stringParts.exemplos = "um parente, para pagar algum serviço"; 
        break;
    }

    switch (tipoCadastro.tipoNecessidade) {
      case "EnviarParaExterior": 
        stringParts.operacao = "enviar valores para o exterior, ";
        stringParts.mensagem = "Está enviando para "; 
        break;
      case "ReceberDoExterior": 
        stringParts.operacao = "receber valores do exterior, "; 
        stringParts.mensagem = "Está recebendo de "; 
        break;
    }

    let produto = this.props.produtos.find(function (element) {
      return element.value === tipoCadastro.tipoProdutoValue
    }).label;

    stringParts.produto = produto.charAt(0).toLowerCase() + produto.replace('¹','').substring(1, produto.length) + ".";

    return (
      <p>
        {"Pronto, para finalizar conte-nos um pouco mais sobre você."}
        <br /> 
        <br />
        <br />
        {"Já sei que você precisa "}<strong>{stringParts.operacao + stringParts.produto}</strong>
        <br />
        <br />
        {"Consegue me explicar mais um pouquinho? "}{stringParts.mensagem + stringParts.exemplos}{", o que seria?"}
      </p>
    )
  }

  render() {

    let {
      maisDetalhes_field
    } = this.props.formMaisDetalhes;


    let {
      setMaisDetalhesFieldAction
    } = this.props;

    return (
      <section className="container">
        <div className="col">
          <Breadcrumbs />
        </div>

        <div className="col">
          {this.textAreaLabel()}
        </div>

        <CheckObligation field="maisDetalhes_field">
          {(validacoes) =>
            <div className="col">
              <AreaField
                type="text"
                placeholder="Diga-nos mais sobre você"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label=""
                name="maisDetalhes_field"
                minlength={3}
                maxlength={1000}
                rows={8}
                value={maisDetalhes_field}
                onChange={(ev, value) => {
                  setMaisDetalhesFieldAction(value)
                }} />
            </div>}
        </CheckObligation>

        <div className="col">
          <NavigationButtons history={this.props.history} validateFields={false} />
        </div>
      </section>
    );
  }


  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  validateFields = async () => {
    let list = []
    let countMounted = 0

    return new Promise(resolve => {
      if (Object.keys(this.formFields).length === 0) {
        resolve([])
      }

      for (let key in this.formFields) {
        if (this.formFields[key]._isMounted) {
          countMounted++
          this.formFields[key].validate(this.formFields[key].input)

            // eslint-disable-next-line no-loop-func
            .then(r => {
              list.push({ name: this.formFields[key].props.name, valid: r })

              if (countMounted === list.length) {
                resolve(list)
              }
            })
        }
      }
    })
  }
}

export default MaisDetalhes;
